var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toasts"},[_c('transition-group',{attrs:{"name":"toast"}},_vm._l((_vm.toasts),function(toast){return _c('div',{key:toast.id,staticClass:"toast",on:{"click":function($event){return _vm.removeToast(toast.id)}}},[_vm._v(" "+_vm._s(toast.message)+" ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }